
import colors from "../../utils/colors";

import { createUseStyles } from 'react-jss';

var styles = {
  tableHead: {
    display: 'block',
    width: '100%',
    font: {
      size: '1.4rem',
      lineHeight: '2rem',
      weight: 700,
      style: 'normal'
    },
    letterSpacing: '0.05rem',
    textTransform: 'uppercase',
    borderBottom: ['0.1rem', 'solid', colors.neutral[500]]
  },
  headerInfoBlock: {
    backgroundColor: colors.neutral.white,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '2rem',
    width: '100%'
  },
  totalTitle: {
    width: '30%',
    textTransform: 'capitalize',
    textAlign: 'right',
    font: {
      size: '1.6rem'
    },
    lineHeight: '1.8rem',
    fontWeight: 400,
    marginBottom: '2rem'
  },
  totalElements: {
    marginLeft: '1rem'
  },
  searchBlock: {
    display: 'flex',
    alignItems: 'center',
    width: '70%'
  },
  searchButtons: {
    display: 'flex',
    alignItems: 'center'
  },
  actionButton: {
    height: '4.4rem',
    minWidth: '10rem',
    '&:first-child': {
      margin: '0 1rem 0 2rem'
    }
  },
  searchInput: {
    width: '32rem'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map